module.exports = __webpack_public_path__ + "img/lixianhuancun .6b95af38.svg";